import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchErpDemand, fetchErpRequests } from '../api/erpDemand';
import { adminKeys } from '../api/organizations';

export const useAdminErpDemand = () =>
  useQuery({ queryKey: adminKeys.erpDemand, queryFn: fetchErpDemand });

/** useCgTable's `useData` shape; keepPreviousData keeps the table from blanking on page change. */
export const useAdminErpRequests = ({ pagination } = {}) =>
  useQuery({
    queryKey: adminKeys.erpRequests(pagination),
    queryFn: () => fetchErpRequests(pagination),
    placeholderData: keepPreviousData,
  });
